import MockExternalManager from "./MockExternalManager";

const DefaultManager = new MockExternalManager();

export default DefaultManager;